import { dateTime12, DD_SLASH_MMM_SLASH_YYYY } from '../../../../constants/dateFormat';
import { formatDate } from '../../../../services/date';

export function formatEdited(instruction) {
  const formatted = formatDate(instruction?.updatedAt || instruction?.createdAt, DD_SLASH_MMM_SLASH_YYYY);
  return formatted ? `Edited ${formatted}` : null;
}

export function formatCreatedBy(instruction) {
  return instruction?.createdByName || instruction?.createdBy || null;
}

export function formatExecutionTime(ms) {
  if (ms === null || ms === undefined || Number.isNaN(Number(ms))) {
    return null;
  }
  const value = Number(ms);
  if (value < 1000) {
    return `${Math.round(value)} ms`;
  }
  return `${(value / 1000).toFixed(1)} s`;
}

export function formatRefreshedAt(value) {
  return formatDate(value, dateTime12);
}

export function formatCellValue(cell) {
  if (cell === null || cell === undefined) {
    return '';
  }
  if (typeof cell === 'object') {
    return JSON.stringify(cell);
  }
  return String(cell);
}
